const tituloPadraoDePagina = {
  office: 'Office.ADV',
  mirt: 'Mirt - Office.ADV - Preâmbulo Office'
}

const nomeRotaLogin = 'login'

const nomeRotaSignupUsuario = 'signup'

const tipoPlano = {
  mensal: 1,
  credito: 2
}

const nomeRotaLoginComEscritorioNaURL = 'loginEscritorio'

const nomeRotaRetornoSso = 'ssoRetorno'

const nomeRotaLoginLite = 'loginLite'

const nomeRotaLoginLiteToken = 'loginLiteToken'

const nomeRotaLoginGestaoConta = 'loginGestaoConta'

const nomeRotaLoginManagerToken = 'loginManagerToken'

const nomeRotaInicioAreaGestaoConta = 'contratos'

const nomeRotaPendenciasDeLogin = 'pendenciasDeLogin'

const nomeRotaRecuperacaoSenha = 'recuperar-senha'

const nomeRotaRecuperacaoSenhaOffice = 'recuperar-senha-office'

const nomeRotaRedefinicaoSenhaOffice = 'redefinir-senha-office'

const nomeRotaEdicaoEscritorio = 'edicao-escritorio-usuario'

const nomeRotaMercado = 'mercado'

const nomeRotaAlterarPlano = 'alterar-plano-contrato'

const nomeRotaUpgradePlano = 'carrinho/upgrade'

const nomeRotaListagemFaturas = 'faturas'

const nomeRotaTelaInicialContextoLegacy = 'inicio'

const listaRotasPublicas = {
  rotaLoginSistemaLegal: nomeRotaLogin,
  rotaSignUp: nomeRotaSignupUsuario,
  rotaLoginEscritorioNaUrl: nomeRotaLoginComEscritorioNaURL,
  rotaLoginLite: nomeRotaLoginLite, // provisório, depois deverá ser removido
  rotaLoginLiteToken: nomeRotaLoginLiteToken,
  rotaLoginGestaoConta: nomeRotaLoginGestaoConta,
  rotaLoginManagerToken: nomeRotaLoginManagerToken,
  rotaPendenciasDeLogin: nomeRotaPendenciasDeLogin,
  rotaRecuperacaoSenha: nomeRotaRecuperacaoSenha,
  rotaRecuperacaoSenhaOffice: nomeRotaRecuperacaoSenhaOffice,
  rotaRedefinicaoSenhaOffice: nomeRotaRedefinicaoSenhaOffice,
  rotaRetornoSso: nomeRotaRetornoSso
}

const modoAutenticacaoSso = {
  legado: 'LEGADO',
  ssoExclusivo: 'SSO_EXCLUSIVO'
}

const listaRotasFaturamento = {
  rotaListagemFaturas: nomeRotaListagemFaturas,
  rotaDetalhesFatura: 'faturaDetalhes',
  rotaFaturaConfiguracaoPagamento: 'carrinho',
  rotaListagemPedidos: 'pedidos',
  rotaDetalhesPedido: 'faturaDetalhes',
  rotaConsumo: 'consumo'
}

const loginStrategy = {
  legacyLogin: 'LEGACY_LOGIN',
  managerLogin: 'MANAGER_LOGIN'
}

const defaultRegistrosCombo = 20
const defaultRegistrosPaginados = 100

const defaultRegistrosCapa = {
  convites: 4,
  noticias: 4
}

const teclado = {
  enter: 13
}

const permissaoAcordo = {
  id: 6
}

const tipoCorrespondente = {
  comum: 1,
  comumLabel: 'Comum',
  parceiro: 2,
  parceiroLabel: 'Parceiro'
}

const statusUsuario = {
  ativo: 1,
  ativoLabel: 'Ativo',
  inativo: 0,
  inativoLabel: 'Inativo',
  loginNaoRealizado: 2,
  loginNaoRealizadoLabel: 'Não realizou login'
}

const statusEscritorio = {
  ativo: 1,
  ativoLabel: 'Ativo',
  inativo: 0,
  inativoLabel: 'Inativo'
}

const statusEvento = {
  pendente: 1,
  pendenteLabel: 'Pendente',
  confirmado: 2,
  confirmadoLabel: 'Confirmado',
  cancelado: 3,
  canceladoLabel: 'Cancelado'
}

const tipoRecorrenciaEventoAgenda = {
  semRecorrencia: null,
  semRecorrenciaLabel: 'Sem recorrência',
  diario: 1,
  diarioLabel: 'Diário',
  semanal: 2,
  semanalLabel: 'Semanal',
  mensal: 3,
  mensalLabel: 'Mensal'
}

const tipoDeAcessoDoUsuario = {
  administrador: 'admin',
  gestorDeConteudo: 'editor',
  usuarioComum: 'user'
}

const statusConvites = {
  pendente: 1,
  pendenteLabel: 'Pendente',
  aceito: 2,
  aceitoLabel: 'Aceito',
  rejeitado: 3,
  rejeitadoLabel: 'Negado',
  notificacaoCancelamento: 4,
  notificacaoCancelamentoLabel: 'Convite cancelado',
  notificacaoLeituraCancelamento: 5,
  notificacaoConviteAceito: 1,
  notificacaoConviteAceitoLabel: 'Convite aceito',
  notificacaoConviteNegado: 2,
  notificaoConviteNegadoLabel: 'Convite negado',
  notificacaoLeituraConfirmada: 0
}

const acoesCadastroEventoAgenda = {
  salvar: 1,
  excluir: 2
}

const tempoParaAguardarDigitacaoNoCombo = 1000

const urlSistemaExterno = {
  juridico: '/office/login/gerar-acesso',
  faturamento: '/faturamento/login/gerar-acesso',
  financeiro: '/financeiro/login/gerar-acesso',
  relatorios: '/relatorios/login/gerar-acesso',
  bank: process.env.VUE_APP_BANK_URL,
  mirt: '/manager/conta/mirt/login/gerar-acesso'
}

const idProdutoMirt = 7

const statusPagamento = {
  pendente: 1,
  realizado: 2,
  recusado: 3,
  devolvido: 4,
  erro: 1000
}

const statusFatura = {
  cobrancaPaga: 1,
  cobrancaAguardandoConfirmacao: 2,
  cobrancaEmAberto: 3,
  cobrancaAtrasada: 4
}

const planos = {
  starter: '64cd6752-a9c9-462a-9d03-fc021829300c',
  free: '19a43321-ffd9-40e0-b46b-2af57127d50e',
  free_2: '6f1e6b0f-8b0c-4bc3-82a3-e1f7aa5e1a70'
}

const tipoEntidadePessoa = {
  fisica: 1,
  juridica: 2

}

const tipoMonetario = 1
const tipoPercentual = 2

const definicoesContexto = [
  {
    domain: process.env.VUE_APP_OFFICE_ADV_DOMAIN,
    intercomId: process.env.VUE_APP_OFFICE_INTERCOM_ID,
    gtmId: process.env.VUE_APP_OFFICE_GOOGLE_TAG_MANAGER_ID,
    clarityId: process.env.VUE_APP_OFFICE_MICROSOFT_CLARITY_ID
  },
  {
    domain: process.env.VUE_APP_MIRT_DOMAIN,
    intercomId: process.env.VUE_APP_MIRT_INTERCOM_ID,
    gtmId: process.env.VUE_APP_MIRT_GOOGLE_TAG_MANAGER_ID,
    clarityId: process.env.VUE_APP_MIRT_MICROSOFT_CLARITY_ID
  }
]

const contextoEmpresa = {
  office: 1,
  mirt: 7
}

export default {
  urlSistemaExterno,
  tituloPadraoDePagina,
  nomeRotaLogin,
  nomeRotaLoginComEscritorioNaURL,
  nomeRotaRetornoSso,
  modoAutenticacaoSso,
  nomeRotaSignupUsuario,
  nomeRotaLoginLite,
  nomeRotaLoginLiteToken,
  permissaoAcordo,
  defaultRegistrosCombo,
  tipoCorrespondente,
  statusUsuario,
  statusEscritorio,
  teclado,
  statusEvento,
  tipoDeAcessoDoUsuario,
  statusConvites,
  defaultRegistrosCapa,
  tempoParaAguardarDigitacaoNoCombo,
  tipoRecorrenciaEventoAgenda,
  acoesCadastroEventoAgenda,
  defaultRegistrosPaginados,
  listaRotasPublicas,
  loginStrategy,
  nomeRotaInicioAreaGestaoConta,
  nomeRotaLoginGestaoConta,
  nomeRotaLoginManagerToken,
  nomeRotaPendenciasDeLogin,
  nomeRotaRedefinicaoSenhaOffice,
  nomeRotaListagemFaturas,
  listaRotasFaturamento,
  nomeRotaEdicaoEscritorio,
  nomeRotaMercado,
  nomeRotaAlterarPlano,
  nomeRotaUpgradePlano,
  idProdutoMirt,
  statusPagamento,
  statusFatura,
  tipoPlano,
  planos,
  tipoEntidadePessoa,
  tipoMonetario,
  tipoPercentual,
  definicoesContexto,
  contextoEmpresa,
  nomeRotaTelaInicialContextoLegacy
}
